export const GhKey = {
  PRODUCT_ID: 'productId',
  PRODUCT_SOLD: 'totalProductSold',
  GH_PER_PRODUCT: 'ghgPerProductKg',
  GH_PERCENT: 'ghgPercentage'
};
export const GhLabel = {
  PRODUCT_ID: 'Product Name',
  PRODUCT_SOLD: 'Quantity of product sold',
  GH_PER_PRODUCT: 'GHGs Per Product',
  GH_PERCENT: 'GHGs Percentage of product'
};
